window.addEventListener('load', function(event) {
  const timelineSwiper = new Swiper('.history-slider__timeline', {
    wrapperClass: 'history-slider__timeline-track',
    slideClass: 'history-slider__timeline-item',
    speed: 700,
    slideToClickedSlide: true,
    slidesPerView: 'auto',
    breakpoints: {
      320: {
        spaceBetween: 20,
      },
      1025: {
        spaceBetween: 44,
      },
      1599: {
        spaceBetween: 70,
      }
    }
  });
  
  const historySwiper = new Swiper('.history-slider__gallery', {
    wrapperClass: 'history-slider__gallery-track',
    slideClass: 'history-slider__gallery-item',
    speed: 700,
    // thumbs: timelineSwiper,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1599: {
        spaceBetween: 0,
        slidesPerView: 1.23,
      }
    }
  });

  document.querySelectorAll('.history-slider__timeline-item').forEach(date => {
    date.addEventListener('click', function(){
      document.querySelector('.history-slider__timeline-item--active').classList.remove('history-slider__timeline-item--active');
      this.classList.add('history-slider__timeline-item--active');

      let index = this.dataset.index;

      historySwiper.slideTo(index, 500);
    })
  })

  historySwiper.on('slideChange', function (e) {
    let index = e.realIndex;
    // console.log(e);
    // console.log(index);
    document.querySelector('.history-slider__timeline-item--active').classList.remove('history-slider__timeline-item--active');
    document.querySelector(`.history-slider__timeline-item[data-index="${index}"]`).classList.add('history-slider__timeline-item--active');
    timelineSwiper.slideTo(index, 500);
  });

  // historySwiper.controller.control = timelineSwiper;
  // timelineSwiper.controller.control = historySwiper;
}, false);